
import { Component, Prop } from "vue-property-decorator";
import { HcPageModel } from "@dev/hc-components";
import IAddress from "@/module/main/model/applicationForm/IAddress";
import { EnumUtil } from "@/app";
import Country from "@/module/main/dto/customer/CountryEnum";

@Component
export default class HcAddress extends HcPageModel {
    @Prop({type: Object}) public value!: IAddress;
    @Prop({type: String}) public title!: string;

    protected pageName: string = "address";

    private get countryData(): object[] {
        return EnumUtil.createSelectDataFromEnum(Country, "Country", true);
    }
}
